<div class="d-flex align-items-center">

  <!-- Display original price if discount applies -->
  @if (priceWithoutDiscount) {
    <div class="discount-line me-2">
      <strong>{{ (priceWithoutDiscount.showIncludedFee ? priceWithoutDiscount.totalWithFee : priceWithoutDiscount.total) | appCurrencyPipe }}</strong>
    </div>
  }

  @if (isEnrollment) {
    <span class="enrollment">
      <strong>{{ (price.showIncludedFee ? price.totalWithFee : price.total) | appCurrencyPipe }}</strong> {{ 'Enrollment' | translate | lowercase }}
    </span>
  } @else {
    <strong>
      {{ (price.showIncludedFee ? price.totalWithFee : price.total) | appCurrencyPipe }}
    </strong>
  }

  <!-- Handle recurring price label if recurrence exists -->
  @if (recurrence && recurrence !== RecurrencesTypes.OneTime) {
    <span class="recurrence ms-1"> / {{ ('INSCRIPTIONS.PAYMENT_RECURRENCES_AUX' + '.' + recurrence) | translate | lowercase }}</span>
  }

</div>
